import envConfig from './env';

export default {
  config: {
    // 一体机配置
    PageConfig: {
      GetQueryPageConfiguration: envConfig.SuperCode + '/DataService.aspx?function=GetQueryPageConfiguration',
      bindconfig: envConfig.SuperCode + '/JsonDataService.ashx?function=AddQueryPageConfigurationRel'
    },
    // 基础数据
    BaseData: {
      TraceQuery: envConfig.Agriculture + '/JsonDataService.ashx?function=TraceQuery',
      GetAntiFakeQueryResult: envConfig.Agriculture + '/JsonDataService.ashx?function=GetAntiFakeQueryResult',
      ProductBatchCustomFunction: envConfig.Agriculture + '/JsonDataService.ashx?function=ProductBatchCustomFunction',
      AntiFakeQuery: envConfig.Agriculture + '/JsonDataService.ashx?function=AntiFakeQuery',
      GetWeatherInfo: envConfig.SuperCode + '/JsonDataService.ashx?function=GetWeatherInfo&Type=Point',
      getAndroidToken: '/main.aspx?function=gettoken',
      GetProductBatchTraceNode: envConfig.SuperCode + '/JsonDataService.ashx?function=GetProductBatchTraceNode',
      GetWeatherStationList: envConfig.SuperCode + '/DataService.aspx?Function=GetWeatherStationList',
      GetWeatherStationListByProductBatchID: envConfig.interfaceSuperCode + '/JsonDataService.ashx?function=GetWeatherStationList',
      GetLatestWeatherRecord: envConfig.SuperCode + '/DataService.aspx?Function=GetLatestWeatherRecord',
      GetWeatherAllDayInfoByType: envConfig.SuperCode + '/DataService.aspx?Function=GetWeatherAllDayInfoByType',
      GetEnterpriseAchievementPublic: envConfig.Agriculture + '/JsonDataService.ashx?function=GetEnterpriseAchievementPublic',
      //
      PackCodeQueryCheck: envConfig.SuperCode + '/DataService.aspx?Function=PackCodeQueryCheck',
      BatchProductPack: envConfig.SuperCode + '/DataService.aspx?Function=BatchProductPack',
      GetPackBatchProductList: envConfig.SuperCode + '/DataService.aspx?Function=GetPackBatchProductList',
      GetBlockchain: envConfig.SuperCode + '/JsonDataService.ashx?function=GetBlockChainInfo',
      GetBlockchainList: envConfig.SuperCode + '/JsonDataService.ashx?function=GetTraceBlockChainDetailList',
      GetStampList: envConfig.SuperCode + '/JsonDataService.ashx?Function=GetTimesTampRecord',
      //获取扶贫信息
      GetPoorInfo: envConfig.interfaceSuperCode + '/JsonDataService.ashx?function=GetPoorInfoByProductBatch'
    }
  },
  install(Vue) {
    Vue.prototype.$urlAPI = this.config;
    Vue.urlAPI = this.config;
  }
};



// WEBPACK FOOTER //
// ./src/config/urlApi.js